export default "__VITE_ASSET__BJvfPEzP__"